import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from '../../../service/enrollmentAcceptedStudent.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, map } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { FileService } from 'src/app/service/file.service';
declare var $: any;

@Component({
  selector: 'app-accepted-student',
  templateUrl: './accepted-student.component.html',
  styleUrls: ['./accepted-student.component.scss']
})
export class AcceptedStudentComponent implements OnInit {

  showLoader: boolean = false;
  students: any;
  editAcceptCand:any;
  currentStudentName = "";
  currentStudentId = 0;
  table: any;
  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;
  orderByFields: any;
  orderTypes: any;
  username: any;
  orgId: any;
  semeterId: any;
  yearId: any;
  batchId:any;
  candImageFile:any;
  candImageUrl:any;
  candUploadImage:any;
  candImageFileName:any;
  // applyUpdateButtonView = false;
  finalizeEnrollmentButtonView = false;
  isGenerateMatNo = false;
  enrollmentStatus="";
  // enrolmentFinalizedFlag=false;
  enrolmentFinalizedFlag=true;
  orderingForm = new FormGroup({
    orderByField: new FormControl('', [
      Validators.required,
    ]),
    orderType: new FormControl('', [
      Validators.required,
    ]),
  });

  modifyForm = new FormGroup({
    fullNameAr: new FormControl('', [
      Validators.required,
    ]),
    firstNameAr: new FormControl('', [
      Validators.required,
    ]),
    lastNameAr: new FormControl('', [
      Validators.required,
    ]),
    fullNameEnglish: new FormControl('', [
      Validators.required,
    ]),
    firstNameEn: new FormControl('', [
      Validators.required,
    ]),
    lastNameEn: new FormControl('', [
      Validators.required,
    ]),
    gender: new FormControl('', [
      Validators.required,
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),

    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    address: new FormControl('', [
      Validators.required,
    ]),
    nationalId: new FormControl('', [
      Validators.required,
      Validators.pattern(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/)

    ]),
    picture: new FormControl('', [
      //Validators.required,
    ]),
  });

  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router
    , public translate: TranslateService,private fileService: FileService) {

  }

  ngOnInit(): void {
    this.getAllStudents('getAcceptedCandidates');
    this.username = this.globals.currentUserInfo.username;
    this.orgId = this.globals.currentUserInfo.orgid;
    this.yearId = this.globals.currentUserInfo.yearid;
    this.batchId = this.globals.currentUserInfo.batchId;
    this.semeterId = this.globals.currentUserInfo.semesterid;
    // Listen for language change to update table
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      this.initFormDropDownsFields();
    });
  }

  /**
   * serviceName = (getAcceptedCandidates OR reloadAcceptedCandidatesAndResetOrder OR getNewlyAcceptedCandidates)
   */
  getAllStudents(serviceName: string = 'getAcceptedCandidates', fieldName: string = '', orderType: string = '') {
    this.showLoader = true;
    // this.enrollmentAcceptedStudentService.getAcceptedCandidates()
    (this.enrollmentAcceptedStudentService as any)[serviceName](this.username, fieldName, orderType)
      .subscribe(
        (data: any) => {
          let counter = 0;
          data.map((element: any) => {
            counter += 1;
            element.no = counter;
          });
          this.students = data;
          console.log(this.students);
          this.updateTable();
          this.initFormDropDownsFields();
          this.getEnrollmentHeader();
        },
        (error: any) => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false

        },
        () => this.showLoader = false
      );

    // Test Data
    // this.students = [
    //   {
    //     no: 1,
    //     matNo: 10,
    //     fullNameEn: "test full name en",
    //     fullNameAr: "test full name ar",
    //     firstName: "test first name",
    //     lastName: "test last name",
    //     email: "test email",
    //     phone: "test phone",
    //     address: "test address",
    //     nationalId: "test national id",
    //     picture: "https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0"
    //   },
    //   {
    //     no: 2,
    //     matNo: 20,
    //     fullNameEn: "test full name en",
    //     fullNameAr: "test full name ar",
    //     firstName: "test first name",
    //     lastName: "test last name",
    //     email: "test email",
    //     phone: "test phone",
    //     address: "test address",
    //     nationalId: "test national id",
    //     picture: "https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0"
    //   },
    //   {
    //     no: 3,
    //     matNo: 30,
    //     fullNameEn: "test full name en",
    //     fullNameAr: "test full name ar",
    //     firstName: "test first name",
    //     lastName: "test last name",
    //     email: "test email",
    //     phone: "test phone",
    //     address: "test address",
    //     nationalId: "test national id",
    //     picture: "https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0"
    //   },
    // ];
    // this.updateTable();
  }

  updateTable() {
    // this.getTitles();
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        rowReorder: true,
        "columnDefs": [
          { orderable: true, className: 'reorder', targets: [0] },
          { orderable: false, targets: '_all' }
        ],
        // pageLength: 5,
        paging: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          messageTop:this.getTitles(),
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'EXCEL',
          title:this.translate.instant('SEMESTER_AND_GRADE_DESCRIPTION_REPORT'),
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
          },
          className: 'datatable_custom_buttons',
        }],
      });

      let dataTableButtonsDiv = <HTMLElement>document.getElementsByClassName('dt-buttons')[0];
      if(dataTableButtonsDiv != null){
        dataTableButtonsDiv.style.padding = '0px 15px 0px 15px';
      }
      // Test datatable function start
      // console.log(table.rows({ search: 'applied', order: 'applied' }).data());
      // table.on('row-reordered', function (e: any, details: any, edit: any) {
      // console.log(table.rows({order:'current'}).data());
      // console.log('row-reordered');
      // console.log(table.rows().data());
      // var indexes = table.rows().indexes().toArray();
      // for (var r = 0; r < indexes.length; r++) {
      //   //get row data
      //   var data = table.row(indexes[r]).data();
      //   console.log(data);
      // }
      // });
      // Test datatable function end

    }, 1);
  }
  getCurrentStudent(courseId: any) {
    this.currentStudentName = this.students.filter((i: any) => i.id == courseId)[0].name;
    this.currentStudentId = courseId;
  }

  editStudent(id: any) {
    this.router.navigate(
      ['/enrolment/update-course'],
      { queryParams: { courseId: id } });
    // console.log(this.table.rows({ order: 'current' }).data());
  }

  // deleteStudent(id: any) {
  //   this.systemService.deleteCountry(id)
  //     .subscribe(
  //       data => {
  //         window.location.reload();
  //       },
  //       error => {
  //         this.toastrService.show(this.translate.instant('CAN_NOT_DELETE'));

  //       }
  //     );
  // }

  getBase64(event: any, index: number) {
    let img = event.target;
    let dataURL: any;
    var canvas = document.createElement('canvas');
    let ctx: any;
    ctx = canvas.getContext('2d');
    // canvas.height = img.height;
    // canvas.width = img.width;

    // canvas.height = img.clientHeight;
    // canvas.width = img.clientWidth;

    canvas.height = img.naturalHeight;
    canvas.width = img.naturalWidth;
    // let newWidth = 100;
    // let newHeight = 100;
    ctx.drawImage(img, 0, 0);
    // ctx.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL('image/jpeg');
    // this.candidateInquiriesData[index].imageBase64 = dataURL;
    // console.log("test func: ");
    // console.log(dataURL);
    // console.log("data: ");
    // console.log(this.data);
  }

  getLastMatNumber() {
    this.rearrangeStudentListAccordingToTable();
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.getLastMatNumber(this.orgId)
      .subscribe(
        data => {
          let lastMatNumber = data[0];

          let counter = 0;
          this.students.map((element: any) => {
            lastMatNumber += 1;
            element.stuCode = lastMatNumber;
          });

          this.updateTable();
          // this.applyUpdateButtonView = true;
          this.finalizeEnrollmentButtonView = false;
          this.isGenerateMatNo = true;
        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false

        },
        () => this.showLoader = false
      );
  }

  initFormDropDownsFields() {
    this.orderByFields = [{ key: 'serialno', value: this.translate.instant('SERIAL_No') }, { key: 'stuCode', value: this.translate.instant('STUDENT_CODE') }, { key: 'fullNameAr', value: this.translate.instant('FULL_NAME_ARABIC') }, { key: 'firstNameAr', value: this.translate.instant('FIRST_NAME_AR') }, { key: 'lastNameAr', value: this.translate.instant('LAST_NAME_AR') }, { key: 'fullNameEn', value: this.translate.instant('FULL_NAME_ENGLISH') }, { key: 'firstNameEn', value: this.translate.instant('FIRST_NAME_EN') }, { key: 'lastNameEn', value: this.translate.instant('LAST_NAME_EN') }, { key: 'gender', value: this.translate.instant('GENDER') }, { key: 'email', value: this.translate.instant('EMAIL') }, { key: 'mobileNo', value: this.translate.instant('MOBILE') }, { key: 'address', value: this.translate.instant('ADDRESS') }, { key: 'nidNo', value: this.translate.instant('NID') }];
    this.orderTypes = [{ key: 'A', value: this.translate.instant('ASCENDING_ORDER') }, { key: 'D', value: this.translate.instant('DESCENDING_ORDER') }];
  }

  orderingFormChange() { }
  orderingFormSubmit() {
    if (this.orderingForm.valid) {
      let fieldName = this.orderingForm.controls.orderByField.value;
      let orderBy = this.orderingForm.controls.orderType.value;
      this.getAllStudents('getAcceptedCandidatesOrderBy', fieldName, orderBy);
    } else {
      this.orderingForm.markAllAsTouched();
      this.orderingForm.markAsDirty();
    }
  }

  reloadCandidates() {
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.reloadAcceptedCandidatesAndResetOrder(this.username)
      .subscribe(
        data => {
          this.getAllStudents('getAcceptedCandidates');
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false
          this.updateTable();

        }
      );
  }

  checkForNewCandidates() {
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.getNewlyAcceptedCandidates(this.username)
      .subscribe(
        data => {
          this.getAllStudents('getAcceptedCandidates');
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false
          this.updateTable();

        }
      );
  }

  editCand(id :any){
    console.log("edit cand : "+id);
    this.candImageFile=null;
    this.candImageUrl=null;
    this.candUploadImage=null;
    this.candImageFileName="";
    this.editAcceptCand = this.students.filter((i: any) => i.id == id)[0];
    this.modifyForm.controls.fullNameAr.setValue(this.editAcceptCand.fullNameAr);
    this.modifyForm.controls.firstNameAr.setValue(this.editAcceptCand.firstNameAr);
    this.modifyForm.controls.lastNameAr.setValue(this.editAcceptCand.lastNameAr);
    this.modifyForm.controls.fullNameEnglish.setValue(this.editAcceptCand.fullNameEn);
    this.modifyForm.controls.firstNameEn.setValue(this.editAcceptCand.firstNameEn);
    this.modifyForm.controls.lastNameEn.setValue(this.editAcceptCand.lastNameEn);
    this.modifyForm.controls.gender.setValue(this.editAcceptCand.gender);
    this.modifyForm.controls.email.setValue(this.editAcceptCand.email);
    this.modifyForm.controls.phoneNumber.setValue(this.editAcceptCand.mobileNo);
    this.modifyForm.controls.address.setValue(this.editAcceptCand.address);
    this.modifyForm.controls.nationalId.setValue(this.editAcceptCand.nidNo);
    this.modifyForm.controls.picture.setValue(this.editAcceptCand.photoFilename);
  }
  editCandSubmit(){
      if (this.modifyForm.valid) {
        console.log("in side cond 1")
        this.finalizeEnrollmentButtonView = false;
       this.students.map((element: any)=>{
          if( element.id == this.editAcceptCand.id){
            console.log("in side cond 2")
            element.fullNameAr=this.modifyForm.controls.fullNameAr.value;
            element.firstNameAr=this.modifyForm.controls.firstNameAr.value;
            element.lastNameAr=this.modifyForm.controls.lastNameAr.value;
            element.fullNameEn=this.modifyForm.controls.fullNameEnglish.value;
            element.firstNameEn=this.modifyForm.controls.firstNameEn.value;
            element.lastNameEn=this.modifyForm.controls.lastNameEn.value;
            element.gender=this.modifyForm.controls.gender.value;
            element.email=this.modifyForm.controls.email.value;
            element.mobileNo=this.modifyForm.controls.phoneNumber.value;
            element.address=this.modifyForm.controls.address.value;
            element.nidNo=this.editAcceptCand.nidNo;
            if(this.candUploadImage!=null){
              console.log("in pic");
              console.log(this.modifyForm.controls.picture.value);
              //photo still
              this.handleUploadFile(); 
              element.photoFilename=this.candImageFileName;
            }
            
          }
          return element;
        });


        $('#close-EditAcceptCand').click();
        console.log(this.students)
      } else {
        this.modifyForm.markAllAsTouched();
        this.modifyForm.markAsDirty();
      }

  }

  rearrangeStudentListAccordingToTable(){
    let currentDatatableRows = this.table.rows({ order: 'current' }).data().toArray();
    let newStudentListOrder:any = [];
    let oldStudentListOrder = this.students;
    currentDatatableRows.forEach((element: any) => {
      let found = false;
      oldStudentListOrder = oldStudentListOrder.filter((student: any)=>{
        if(!found && element[1] == student.serialno){
          newStudentListOrder.push(student);
          found = true;
          return false;
        }else{
          return true;
        }
      });
    });

    this.students = newStudentListOrder;
    let counter = 0;
    this.students.map((element: any) => {
      counter += 1;
      element.no = counter;
    });
  }

  applyStudentsUpdate(){
    this.showLoader = true;
    // let bulkApis = [];
    let bulkApis  = this.students.map((student:any)=>{
      return this.enrollmentAcceptedStudentService.updateAcceptedStudent(this.username, student).pipe(map(res => res), catchError(e => of('Oops!')));
    });

    forkJoin(bulkApis).subscribe(
      data => {
        let studentsupdateFail = 0;
        let studentsupdateSuccess = 0;
        data.forEach((msg: any) => {
          if(msg.sts == 'SUCCESS')
          {
            studentsupdateSuccess++;
          }else{
            studentsupdateFail++;
          }
        });

        if(studentsupdateFail === 0 && this.isGenerateMatNo)
        {
          this.finalizeEnrollmentButtonView = true;
        }

        this.toastrService.info(this.translate.instant("SUCCESS")+" ("+studentsupdateSuccess+") "+this.translate.instant("FAIL")+" ("+studentsupdateFail+").");

      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
      },
      ()=>{
        this.showLoader = false;
        this.updateTable();
      }
    );
    // console.log(this.students);
    // console.log(bulkApis);
    // this.students.forEach((element:any) => {
    //   // .pipe(map(res => res), catchError(e => of('Oops!')))
    // });
  }

  candChangeImage(event: any) {
    this.candImageFile=null;
    this.candImageUrl=null;
    this.candUploadImage=null;
    let typesAccept = ['image/png', 'image/jpeg', 'image/jpg'];
    // Max size 200 MEGA
    var maxSize = 209715200;
    
    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);

      // if ((currentFile.type == oldExcel || currentFile.type == excel) && currentFile.size <= maxSize) {
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.candImageFile = event.target.files[0];
        var reader = new FileReader();

        reader.readAsDataURL(currentFile); // read file as data url

        reader.onload = (event) => { // called once readAsDataURL is completed
          this.candImageUrl = event.target?.result;
        }
        this.candUploadImage = currentFile;
        console.log("accepted extention");
        return true;
      } else {
        console.log(currentFile.type);
        console.log("wrong extention");
        //this.basicData.controls.userImage.reset();
        this.candUploadImage = '';
        //this.basicData.controls.userImage.markAsDirty();
        //this.basicData.controls.userImage.markAsTouched();
        if (currentFile.size > maxSize) {
          this.toastrService.error(this.translate.instant('MAX_FILE_SIZE_200_MB'));
        }
        return false;
      }
    }
    else {
      return false;
    }
  }

  handleUploadFile() {
    let formData = new FormData();

    let fname = this.candImageFile.name.split('.').slice(0, -1).join('.')
    let fext = this.candImageFile.name.split('.').pop()
    this.candImageFileName = fname + "_" + Date.now() + "." + fext
    formData.append('file', this.candImageFile, this.candImageFileName);

    this.fileService.uploadFile(formData).subscribe(
      data => {
       // this.updateCandBasicData()
      },
      error => {
       // this.creating = false
        this.toastrService.warning(this.translate.instant("CAN_NOT_UPLOAD_USER_IMAGE"));
      }
    );
  }

  submitFinalizeEnrollment() {
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.saveSemesterNewCandsEnrollment(this.orgId, this.yearId, this.semeterId, this.username)
      .subscribe(
        data => {
          this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
          this.getEnrollmentHeader();
          this.showLoader = false
          this.updateTable();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
          this.showLoader = false
          this.updateTable();
        }
      );
  }

  getEnrollmentHeader() {
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.getEnrollmentHeader(this.orgId, this.yearId, this.semeterId)
      .subscribe(
        data => {
          this.enrollmentStatus=data[0].status;
          if(this.enrollmentStatus=="FINAL"){
            this.enrolmentFinalizedFlag=true;
          }else{
            this.enrolmentFinalizedFlag=false;
          }
        //  this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false
          this.updateTable();
        }
      );
  }

  public getTitles():string{
    var gradeTitle:string=this.translate.instant('BATCH');
    var yearTitle:string=this.translate.instant('ACADMIC_YEAR');
    var semesterTitle:string=this.translate.instant('SEMESTER');
    let firstStudent=this.students[0];
    console.log(firstStudent);
    let title = semesterTitle.concat(' : '+(this.globals.lang=='ar'?firstStudent.semesterNameAr:firstStudent.semesterNameEn))
    .concat('   ,   ')
    .concat(yearTitle).concat(' : '+(this.globals.lang=='ar'?firstStudent.yearNameAr:firstStudent.yearNameEn))
    .concat('   ,   ')
    .concat(gradeTitle).concat(' : '+(this.globals.lang=='ar'?firstStudent.gradeNameAr:firstStudent.gradeNameEn));
    //  console.log(title);
    // console.log(this.globals.currentUserInfo);
    return title;
  }
}
